export type AssetCategoryRateValue = {Cat: string, Rate: number}[] | null
